import { useLoginStore } from '@/login/stores/useLoginStore';
import type { Collection } from '@/newApi/services/ResgateManager';
import { ResErr, ResgateManager } from '@/newApi/services/ResgateManager';
import type { OrganizationEmployment } from '@sysarb/sysarb-types-v2/services/v1/base-registry';
import type { QueryOptions } from '@tanstack/vue-query';
import { queryOptions } from '@tanstack/vue-query';

type EmploymentsOptions = {
    queries: {
        getEmployments: () => QueryOptions<Collection<OrganizationEmployment> | null, Error, OrganizationEmployment[]>;
    };
};

export const employments: EmploymentsOptions = {
    queries: {
        getEmployments: (): QueryOptions<Collection<OrganizationEmployment> | null, Error, OrganizationEmployment[]> => {
            const { instanceTopic, currentOrganisationNodeId } = useLoginStore();
            const topic = `v1.${instanceTopic}.${currentOrganisationNodeId?.toLowerCase()}.base-register.section-manager.employments`;

            return queryOptions<Collection<OrganizationEmployment> | null, Error, OrganizationEmployment[]>({
                meta: {
                    subscribe: true,
                    type: 'resgate',
                    resourceId: topic,
                },
                queryKey: ['section-manager', 'employments', topic],
                queryFn: async (): Promise<Collection<OrganizationEmployment> | null> => {
                    const resgate = ResgateManager.getInstance();
                    const res = await resgate.collection<OrganizationEmployment>(topic);
                    if (res instanceof ResErr) throw new Error(res.message);
                    return res;
                },
                select: data => (data?.list ?? []).toSorted((a, b) => a.name.localeCompare(b.name)),
                enabled: () => currentOrganisationNodeId != null,
            });
        },
    },
};
